<template>
    <v-file-input
      v-model="inputImagem"
      accept="image/png, image/jpeg, image/bmp"
      persistent-placeholder
      label="Logo*"
      outlined
      dense
      :error-messages="inputImagemErrors"
      :success-messages="inputImagemSuccess"
      @input="$v.inputImagem.$touch()"
    >
      <template v-slot:append>
        <p v-if="!inputImagem" class="mr-5 mt-1">{{ empresa.logo_cliente }}</p>
        <v-btn small dark @click="submitForm">Salvar</v-btn>
      </template>
    </v-file-input>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import api from '../../api/cfg';

export default {
  props: ["empresa", "dialog"],
  data: () => ({
    inputImagem: null,
    urlApi: window.__APP_CONFIG__.VUE_APP_URL_BASE,
    srcLogo: null,
    inputImagemSuccess: null
  }),
  validations: {
    inputImagem: {
      required
    }
  },
  computed: {
    inputImagemErrors() {
      const errors = [];
      if (!this.$v.inputImagem.$dirty || this.inputImagemSuccess != null) return errors;
      !this.$v.inputImagem.required && errors.push("Campo Obrigatório.");
      return errors;
    }
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.inputImagemSuccess = null;
        this.$v.$reset();
      }
    }
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const token = localStorage.getItem("token");

        const headers = {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        }

        const params = new FormData();

        params.append('imagem', this.inputImagem);
        params.append('id', this.empresa.id);

        this.$store.dispatch(
          "loading/addRequisicao",
          api.uploadLogo(headers, params)
            .then((response) => {
              const {token, fileName} = response.data;
              localStorage.setItem("token", token);

              if (fileName) {
                this.inputImagem = null;
                this.inputImagemSuccess = "Imagem carregada com sucesso!"

                this.$emit("upload-logo", fileName);
              } else {
                alert('Erro ao carregar a imagem.')
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        )
      }
    }
  }
}
</script>
